import React from 'react'
import Container from '../../../../components/Container'
import { FormAdvertisements } from '../components/Form'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools'

const AdvertisementsCreate = (): JSX.Element => (
  <Container
    pageTitle={nameActions.create.name}
    breadcrumb={breadcrumbCreate}
    tools={toolsCreate}
  >
    <FormAdvertisements typeForm="create" />
  </Container>
)

export default AdvertisementsCreate
